/**
 * Ceci est la page index qui comporte les pagination dans le menu Arrivées et Departs
 *
 * Tous les styles sont en Tailwindcss et components avec Headless UI
 */
import React, { memo, useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import "@routes/IconeSvg";
import { indisponibilityActions } from "@store/actions";
import EmptyData from "@components/tailwindComponents/EmptyData";

import { getInitPeriodFilterMonthe } from "@helpers/_functions";

import EmployeTabFilter from "./employeTabFilter";
import ItemsTables from "./itemsTables";
import DotLoader from "@components/tailwindComponents/DotLoader";

const initFilter = {
  period: getInitPeriodFilterMonthe(),
  type: "",
  employees: [],
};

const Indisponibility = ({toGoToFile}) => {
  const {t} = useTranslation("pages.employés.indisponibility");
  const {list: allLists = [], isLoaded} = useReduxSelector(
    ({onboarding}) => onboarding.indisponibility,
  );
  const [filterLoading, setFilterLoading] = useState(false);
  const [filtersLists, setFiltersLists] = useState(initFilter);
  const [hasAppliedOnce, setHasAppliedOnce] = useState(false);

  const reduxDispatch = useDispatch();
  // useEffect(() => {
  //   if (!allLists?.length && !isLoaded)
  //     reduxDispatch(indisponibilityActions.loadData);
  // }, []);

  useEffect(() => {
  if (!allLists?.length && !isLoaded) {
    reduxDispatch(indisponibilityActions.loadData);
  } else if (!hasAppliedOnce) {
    reduxDispatch(indisponibilityActions.filterData(initFilter.period));
    setHasAppliedOnce(true);
  }
}, [isLoaded, allLists?.length]);


  const getDataFilter = async (filters, dateChanged) => {
    setFilterLoading(true);
    const {period = getInitPeriodFilterMonthe() } = filters;
    if (dateChanged) {
      await reduxDispatch(indisponibilityActions.filterData(period));
    }
    setFiltersLists(filters);
    setHasAppliedOnce(true);
  };

  const indisponibilityFiltered = useMemo(() => {
    const {type, employees, bodyLocation, gravity, injuryNature, mainCause, place, wastedTime, workStop} = filtersLists;
    const newList = allLists?.filter(
      (unav) => {
        if (type && unav.type !== type) return false;
        if (
          employees?.length &&
          !employees.some((_employee) => _employee.id === unav.employer?._id)
        )
          return false;
        if (bodyLocation && unav.bodyLocation !== bodyLocation) return false;
        if (gravity && unav.gravity !== gravity) return false;
        if (injuryNature && unav.injuryNature !== injuryNature) return false;
        if (mainCause && unav.mainCause !== mainCause) return false;
        if (place && unav.place !== place) return false;
        if (wastedTime !== undefined && unav.wastedTime !== wastedTime) return false;
        if (workStop !== undefined && unav.workStop !== workStop) return false;
        return true;
      },
    );
    setTimeout(() => {
      setFilterLoading(false);
    });
    return newList;
  }, [allLists, filtersLists]);
  return (
    <div className=" arh-rounded arh-bg-white arh-p-4 arh-px-9">
      <EmployeTabFilter setDataFilter={getDataFilter} />

      <div
        className="arh-h-full arh-max-h-[calc(100dvh-82px)] arh-min-h-[60dvh] arh-w-full arh-overflow-auto"
        // ref={divRef}
      >
        <table className="arh-mt-7 arh-items-center arh-h-auto arh-w-full arh-table-auto arh-font-poppins">
          <thead className="arh-sticky -arh-top-[1px] arh-z-[2]">
            <tr>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start  arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Employé")}
              </th>
              <th className="arh-whitespace-nowrap arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Période d'indisponibilité")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Type d'indisponibilité")}
              </th>

              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Lieu")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Cause principale")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Nature de la blessure/Maladie")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Emplacement sur le corps")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Gravité")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Perte de temps")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Arrêt de travail")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Notes")}
              </th>
              <th className="arh-bg-greyColor arh-px-4 arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor"></th>
            </tr>
          </thead>
          <tbody>
            {filterLoading ? (
              <tr>
                <td colSpan={12}>
                  <div className="arh-h-[40dvh]">
                    <DotLoader size="small" />
                  </div>
                </td>
              </tr>
            ) : indisponibilityFiltered?.length ? (
              indisponibilityFiltered?.map((_unav) => (
                <ItemsTables
                  key={_unav?._id}
                  indisponibility={_unav}
                  toGoToFile={toGoToFile}
                />
              ))
            ) : (
              <tr>
                <td colSpan={12}>
                  <EmptyData>{t("Aucun détail à afficher")}</EmptyData>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(Indisponibility);
